import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  card: {
    padding: '0.75rem 1rem',
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    borderRadius: '0.5rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
  },
  image: {
    width: '3rem',
    height: '3rem',
    objectFit: 'cover',
    borderRadius: '0.25rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
    '[data-complaint-seen="true"] &': {
      filter: 'grayscale(100%)',
    },
  },
  title: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
  },
  description: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: neutral[60],
  },
});
